module.exports = __webpack_public_path__ + "media/images/career_camp/2023/hero/date-673442b64c3645094eae0d494a5c33d9.svg";